export default {
  acceptedshipment: {
    title: "Accepted Shipment Report",
    period: "Period",
    periodNotSelected: "The period field cannot be empty"
  }
};
